import { render } from "./cpsy.vue?vue&type=template&id=cd2722a4"
import script from "./cpsy.vue?vue&type=script&lang=js"
export * from "./cpsy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\huishan\\项目\\20250520 辉山官网\\源码\\官网-前端\\huishan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__